import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=2921fcdb&"
import script from "./Topic.vue?vue&type=script&lang=js&"
export * from "./Topic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports